import { Fragment, useMemo } from 'react'
import { parseBlocks, parseInline } from '@/lib/assistant-markdown'

function Inline({ text }: { text: string }) {
  return (
    <>
      {parseInline(text).map((t, i) => {
        switch (t.type) {
          case 'bold': return <strong key={i} className="font-semibold">{t.text}</strong>
          case 'italic': return <em key={i}>{t.text}</em>
          case 'code': return <code key={i} className="rounded bg-gray-100 px-1 text-[0.85em] dark:bg-gray-700">{t.text}</code>
          case 'link':
            return (
              <a key={i} href={t.href} target="_blank" rel="noopener noreferrer" className="text-brand-600 underline break-all dark:text-brand-400">
                {t.text}
              </a>
            )
          default: return <Fragment key={i}>{t.text}</Fragment>
        }
      })}
    </>
  )
}

export function MarkdownText({ text }: { text: string }) {
  const blocks = useMemo(() => parseBlocks(text), [text])
  return (
    <div className="space-y-2 text-sm leading-relaxed">
      {blocks.map((b, i) => {
        switch (b.type) {
          case 'ul':
          case 'ol': {
            const List = b.type === 'ul' ? 'ul' : 'ol'
            return (
              <List key={i} className={`${b.type === 'ul' ? 'list-disc' : 'list-decimal'} space-y-1 pl-5`}>
                {b.items.map((item, j) => <li key={j}><Inline text={item} /></li>)}
              </List>
            )
          }
          case 'p':
          case 'heading':
            return (
              <p key={i} className={b.type === 'heading' ? 'font-semibold' : undefined}>
                <Inline text={b.text} />
              </p>
            )
        }
      })}
    </div>
  )
}
